import persistReducer from "redux-persist/lib/persistReducer";
import storage from "redux-persist/lib/storage";
import { ConfigTableconstant } from "./ConfigTableConstant";


const initialState = {
    ConfigTableList: [],
    ConfigTable: {

        isLoading: false,


    },

    ConfigCancelList: [],
}

export const ConfigTableReducer = persistReducer(

    {
        storage,
        key: "ConfigTable",
        whitelist: [' ConfigTableList'],

    },

    (state = initialState, { type, payload }) => {
        switch (type) {
            case ConfigTableconstant.CONFIG_TABLE_REQUEST: {
               
                return {
                    ...state,
                    ConfigTableList: [],
                    ConfigTable: {

                        isLoading: true,


                    },
                };
            }

            case ConfigTableconstant.CONFIG_TABLE_RESPONSE: {

                return {
                    ...state,
                    ConfigTableList: payload,
                    ConfigTable: {

                        isLoading: false,


                    },
                };
            }


            case ConfigTableconstant.CONFIG_UPDATE_CANCEL_REQUEST: {
               
                return {
                    ...state,
                    ConfigCancelList: [],
                    ConfigCancel: {

                        isLoading: true,


                    },
                };
            }

            case ConfigTableconstant.CONFIG_UPDATE_CANCEL_RESPONSE: {

                return {
                    ...state,
                    ConfigCancelList: payload,
                    ConfigCancel: {

                        isLoading: false,


                    },
                };
            }

            default:
                return state;
        }
    }
);